var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noData-box"},[_c('div',{staticClass:"iconImg flex items-middle flex-center"},[_c('Icon',{staticClass:"icon",attrs:{"type":"icon-wushuju1","size":"150","color":"#fff"}})],1),_c('p',[_vm._v("暂无数据")])])
}
var staticRenderFns = []

export { render, staticRenderFns }